export const helcimApiUrl = 'https://secure.myhelcim.com/api/'

export const accountId = '2500300521'
export const apiToken = 'Zk5RQ4T94864Rcjjc5gR2F8SE'
